import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {NewBaseResponseInterface} from "@/common/Http/Interfaces/NewBaseResponseInterface";

const restApiConfig = new RESTAPIConfig();

export interface UpdateFileMeaningPayloadInterface {
    id: string,
    title: string,
    alias: string,
    active: boolean | null,
}

export const UpdateFileMeaningsApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        updateFileMeaning: builder.mutation<NewBaseResponseInterface<unknown, unknown>, UpdateFileMeaningPayloadInterface>({
            query: (body) => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.fileMeaning(),
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error) => {
                if (!error) {
                    return ["FileMeanings"];
                }
                return [];
            }
        })
    })
});

export const {useUpdateFileMeaningMutation} = UpdateFileMeaningsApiSlice;
